import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmWorkforceSkillsRoute: InvariantJiraRoute = {
	name: 'products-jsm-workforce-skills',
	path: '/jira/settings/products/jira-service-management-workforce-skills',
	exact: true,
};
